import React from 'react';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { DISCOUNT_CODE_CATEGORY_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { postDiscountCodeCategory } from '../../../../actions/sales/DiscountCodeCategory';
import DiscountCodeCategoryForm from './DiscountCodeCategoryForm';

const NewDiscountCodeCategory = ({
  breadcrumbs,
  dispatchPostDiscountCodeCategory,
}) => {
  const onSubmit = (formValues) => {
    const subcats = Array.isArray(formValues.discountCodeSubCategoryList)
      ? formValues.discountCodeSubCategoryList
      : [];

    const categoryAuthorizers = Array.isArray(
      formValues.discountCodeCategoryAuthorizerList,
    )
      ? formValues.discountCodeCategoryAuthorizerList
      : [];

    // ✅ Validación original
    if (subcats.length === 0 && categoryAuthorizers.length === 0) {
      toastr.error(
        'Error',
        'Si no agregas subcategorías, debes agregar al menos un autorizador de la categoría.',
      );
      return;
    }

    if (subcats.length > 0 && categoryAuthorizers.length > 0) {
      toastr.error(
        'Error',
        'Si agregas subcategorías, no debes seleccionar autorizadores a nivel de categoría. Elimina los autorizadores de la categoría o remueve las subcategorías.',
      );
      return;
    }

    // Nombre de la categoría (ajústalo según tu modelo)
    const categoryName =
      formValues.name || formValues.categoryName || 'Categoría';

    let discountCodeSubCategoryList = [];

    if (subcats.length > 0) {
      // Caso normal: ya vienen subcategorías
      discountCodeSubCategoryList = subcats.map((subCategory) => ({
        name: subCategory.name,
        active: true,
        discountCodeSubCategoryAuthorizerList:
          subCategory.discountCodeSubCategoryAuthorizerList.map(
            (authorizer) => ({
              discountCodeAuthorizerId: authorizer.value,
              active: true,
            }),
          ),
      }));
    } else {
      discountCodeSubCategoryList = [
        {
          name: categoryName,
          active: true,
          discountCodeSubCategoryAuthorizerList: categoryAuthorizers.map(
            (authorizer) => ({
              discountCodeAuthorizerId: authorizer.value,
              active: true,
            }),
          ),
        },
      ];
    }

    const newFormValues = {
      ...formValues,
      discountCodeSubCategoryList,
      active: formValues.active || true,
    };

    dispatchPostDiscountCodeCategory(newFormValues);
  };

  const content = (
    <DiscountCodeCategoryForm
      onSubmit={onSubmit}
      initialValues={{
        active: true,
      }}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Categoría Código de Descuento"
      subtitle="Crear categoría código de descuento"
      content={content}
    />
  );
};

NewDiscountCodeCategory.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostDiscountCodeCategory: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostDiscountCodeCategory: postDiscountCodeCategory,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categoría de Códigos de Descuento',
      href: DISCOUNT_CODE_CATEGORY_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewDiscountCodeCategory);
